<div
  class="preparation-container d-flex flex-column align-items-center justify-content-space-between text-center mt-10 gap-8 w-100 h-100"
  [@fadeAnimation]
>
  <div>
    <div class="title">
      <ng-container i18n="@@craftingListeningExperiencePrefix"
        >Sit tight! We are crafting your</ng-container
      >
      <span class="main-color" i18n="@@craftingListeningExperienceHighlight">
        listening experience</span
      >
    </div>

    <div class="w-100 mt-24 fw-light fs-16">
      @for (section of progressSections; track section) {
        <div class="mt-16 d-flex justify-content-space-between w-100">
          <span>{{ section.label }}</span>
          <span [ngClass]="getCompleteClass(section)"> {{ section.displayValue }}% </span>
        </div>
        <mat-progress-bar
          mode="determinate"
          class="instant-update mt-10"
          [class]="section.progressBarClass"
          [value]="section.value"
        >
        </mat-progress-bar>
      }
    </div>
  </div>

  <div class="reviews-carousel-container">
    <div class="reviews-carousel overflow-hidden">
      <div class="reviews d-flex">
        @for (review of userReviews; track review) {
          <div
            class="review bg-light-green-color border-radius p-15 gap-16 d-flex flex-column justify-content-start"
          >
            <div class="d-flex gap-8 align-items-center">
              @if (review.avatarUrl) {
                <img class="avatar" [src]="review.avatarUrl" />
              }
              <div class="d-flex flex-column flex-grow-1">
                <div class="name">{{ review.name }}</div>
                <div class="subtitle" i18n="@@reviewAgeLabel">{{ review.age }} years old</div>
              </div>
              <div class="d-flex align-items-center gap-4">
                <span class="review-stars">●</span>
                @if (review.rate) {
                  <span class="review-rate">{{ review.rate }}</span>
                }
              </div>
            </div>
            <div class="message">{{ review.message }}</div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
